import {EntityService} from '../../../service/EntityService';

export class InvoiceSettingDefaultService extends EntityService {

  static entity = 'app/invoice-setting-default';

  static getGroupTypeCode(): Promise<any> {
    return this.axios.get(`${this.entity}/group-type-code`).then(res => res.data);
  }

  static getNumericColumns(typeInvoiceId: string, groupTypeCode: string): Promise<any> {
    return this.axios.get(`${this.entity}/numeric-columns/${typeInvoiceId}`, {params: {typeInvoiceId, groupTypeCode}}).then(res => res.data);
  }

}
